import { render, staticRenderFns } from "./data59.vue?vue&type=template&id=3997fb2a&scoped=true"
import script from "./data59.vue?vue&type=script&lang=js"
export * from "./data59.vue?vue&type=script&lang=js"
import style1 from "./data59.vue?vue&type=style&index=1&id=3997fb2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997fb2a",
  null
  
)

export default component.exports